export default {"src":"/_next/static/media/delete-icon.2725d6a3.svg","height":12,"width":10};